<script setup lang="ts">
// Layout da área do afiliado (/{idioma}/afiliado): o header e o rodapé reais do
// site, sem o que o layout padrão carrega para assinante e visitante — modais de
// promoção, newsletter e saída do assine, rastreio de ?partner, push, planos,
// user_id no GTM e o aviso 18+ (pendência do Thiago, plano §11). O banner de
// cookies fica.
import MainHeader from "./Header/index.vue";
import MainFooter from "./Footer/index.vue";
import MetaTags from "./MetaTags.vue";
import ModalMessages from "@/components/Modais/ModalMessages.vue";
import ModalAcceptCookies from "@/components/Modais/ModalAcceptCookies.vue";

// Classe no body só enquanto a área está aberta: ver o <style> abaixo.
useHead({ bodyAttrs: { class: "corpo-area-afiliado" } });

const isOpenMenu = ref(false);
const showModalCookies = ref(false);
const options = ref({
  showModal: false,
  titleModal: "",
  textBodyModal: "",
  textButtonModal: "",
  routerName: "",
  presente: false,
});

onMounted(() => {
  // Mesmo atraso do layout padrão, que deixa os outros modais abrirem primeiro.
  setTimeout(() => {
    showModalCookies.value = true;
  }, 5000);
});

function showMenuLateral(value: boolean) {
  isOpenMenu.value = value;
}

function showModalMessages(data: {
  message: {
    show: boolean;
    title?: string;
    textBoby?: string;
    textButton?: string;
    routerName?: string;
    presente?: boolean;
  };
}) {
  options.value.showModal = data.message.show;
  options.value.titleModal = data.message.title ?? "";
  options.value.textBodyModal = data.message.textBoby ?? "";
  options.value.textButtonModal = data.message.textButton ?? "";
  options.value.routerName = data.message.routerName ?? "";
  options.value.presente = data.message.presente ?? false;
}
</script>

<template>
  <MetaTags />
  <div class="custom-container">
    <MainHeader :show="isOpenMenu" :marketing="false" @showMenuLateral="showMenuLateral" />
    <div class="layout-afiliado">
      <slot :showModalMessages="showModalMessages" />
    </div>
    <ModalMessages :options="options" @showModalMessages="showModalMessages" />
    <MainFooter @showModalMessages="showModalMessages" />
    <ModalAcceptCookies v-if="showModalCookies" />
  </div>
</template>

<!-- .custom-container, .right-menu e .show-menu: os mesmos do layout padrão. -->
<style src="../assets/css/moldura-site.css"></style>

<style>
/* O body do site tem overflow-x: hidden (_structure.scss), o que faz dele o
   container de rolagem da sidebar sticky do painel: como quem rola é a janela, a
   sidebar subia junto com a página. O clip corta o vazamento horizontal do mesmo
   jeito, sem criar container de rolagem. O html segue com hidden (main.css). */
body.corpo-area-afiliado {
  overflow-x: clip;
}

.layout-afiliado {
  min-height: 100dvh;
  background-color: #f7f4ef;
}
</style>
